import React, { useEffect, useState } from "react";
import {ThunkDispatch} from "@reduxjs/toolkit";
import {useSelector, useDispatch} from 'react-redux'
import {useNavigate, useSearchParams} from "react-router-dom"
import {currentUserActions} from '../reducers/currentUser'
import LoginHeader from "../components/LoginHeader"
import TextInput from '../components/TextInput';
import PasswordInput from '../components/PasswordInput';
import LogoHeader from "../components/LogoHeader";
import CustomButton from '../components/CustomButton';
import NotFoundPage from "../pages/NotFoundPage";
import { validatePassword, validateFieldReq, validateEmail } from "../utils/validation";
import CustomTag from "../components/CustomTag";

const CompanyUserRegister = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
  const navigate = useNavigate()
  const [queryParameters] = useSearchParams()
  const register_code = queryParameters.get("register_code")
  const [errors, setErrors] = useState({
    first_name: "",
    last_name: "",
    password: "",
  });

  useEffect(() => {
    dispatch(currentUserActions.setInitState())
    dispatch(currentUserActions.getUserInitInfo({registerCode: register_code}))
  }, []);
  const currentUser = useSelector((state: any) => state.currentUser)
  const {showPassword, initStaffInfo, passCheckCode} = currentUser
  
  if(passCheckCode && passCheckCode !== "passed"){
    if(passCheckCode === "failed") return <NotFoundPage />;
    return null;
  }

  const companyName = initStaffInfo.staff.company.name
  const firstName = initStaffInfo.staff.first_name
  const lastName = initStaffInfo.staff.last_name
  const email = initStaffInfo.email

  const switchShowPassword = () => {
    dispatch(currentUserActions.switchShowPassword())
  }
  const staffRegister = (event: any) => {
    event.preventDefault()
    const formData = new FormData(event.target);
    const password = formData.get('password')
    const first_name = formData.get('first_name')
    const last_name = formData.get('last_name')
    if (validateFormData(formData)) {
      dispatch(currentUserActions.staffRegister({navigate, register_code, password, first_name, last_name}))
    }
  }

  const validateFormData = (formData) => {
    let formErrors = {
      first_name: "",
      last_name: "",
      password: "",
    };

    const validateLastnameRes = validateFieldReq(formData.get('last_name'), "姓");
    if(validateLastnameRes != true) {
      formErrors.last_name = String(validateLastnameRes);
    }

    const validateFirstnameRes = validateFieldReq(formData.get('first_name'), "名");
    if(validateFirstnameRes != true) {
      formErrors.first_name = String(validateFirstnameRes);
    }

    const validatePasswordRes = validatePassword(formData.get('password'))
    if (validatePasswordRes != true) {
      formErrors.password = String(validatePasswordRes);
    }   
    
    setErrors(formErrors);
    return !Object.values(formErrors).some((error) => error);    
  };

  return (
    <div className="static md:fixed md:inset-0 bg-alu-base">
      <div className="min-w-[24.75rem] static md:absolute md:top-1/2 left-1/2 md:transform md:-translate-x-1/2 md:-translate-y-1/2">
        <LogoHeader view="company" page="advanced"></LogoHeader>
        <div className="bg-white md:rounded-2xl md:shadow-lg md:max-w-[21.4378rem] md:m-auto md:min-h-max min-h-screen w-full py-0 md:py-6">
          <LoginHeader title="新規登録" logoDirection="row"></LoginHeader>
          <div className="flex flex-col items-center justify-center mt-[3.125rem] md:mt-4 px-4 md:px-6 pb-4">
            <form onSubmit={staffRegister} className="bg-white w-full">
              <div className="mb-4">
                <label
                  className="flex items-center mb-2 text-sm gap-1 pointer-events-none alu-text-base-2"
                  htmlFor="companyName"
                >
                  登録先企業
                </label>
                <TextInput
                  disabled
                  id="companyName"
                  name="companyName"
                  placeholder="rakumo 株式会社"
                  defaultValue={companyName}
                  required
                />
              </div>

              <div className="mb-4">
                <div className="flex items-center gap-2 mb-2">
                  <label className="text-sm pointer-events-none leading-none alu-text-base-2" htmlFor="fullname">氏名</label>
                  <CustomTag type="required" />
                </div>
                <div className="flex items-center gap-2">
                  <TextInput
                    id="last_name"
                    name="last_name"
                    placeholder="姓"
                    defaultValue={lastName}
                    type="text"
                  />
                  <TextInput
                    id="first_name"
                    name="first_name"
                    placeholder="名"
                    defaultValue={firstName}
                    type="text"
                  />
                </div>
                {(errors.first_name || errors.last_name) && (
                  <div className="flex items-center gap-2">
                    <span className="alu-text-error text-sm mt-2 w-[50%]">{errors.last_name}</span>
                    <span className="alu-text-error text-sm mt-2 w-[50%]">{errors.first_name}</span>
                  </div>
                )}
              </div>

              <div className="mb-4">
                <label className="block mb-2 text-sm pointer-events-none alu-text-base-2" htmlFor="email">
                  メールアドレス
                </label>
                <TextInput
                  id="email"
                  name="email"
                  placeholder="入力してください"
                  defaultValue={email}
                  disabled
                />
              </div>

              <div className="mb-10">
                <div className="flex items-center gap-2 mb-2">
                  <label className="text-sm pointer-events-none leading-none alu-text-base-2" htmlFor="password">パスワードを設定</label>
                  <CustomTag type="required" />
                </div>
                <PasswordInput
                  id="password"
                  name="password"
                  placeholder="入力してください"
                  error={errors.password.length > 0}
                  errorText={errors.password}
                />
              </div>

              <CustomButton
                type="submit"
                width='full'
              >
                登録する
              </CustomButton>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyUserRegister;